import AppLabelentriesIndex from "./labelEntry.vue";
import AppLabelentriesList from "./list/list.vue";
import AppLabelentriesItem from "./item/item.vue";

const routes = [
  {
    path: "/labelEntry",
    component: AppLabelentriesIndex,
    meta: {
      auth: {
        roles: "labelEntry.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "labelEntry.index",
        component: AppLabelentriesList,
        meta: {
          auth: {
            roles: "labelEntry.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "labelEntry.create",
        component: AppLabelentriesItem,
        meta: {
          auth: {
            roles: "labelEntry.create",
            redirect: { name: "labelEntry.index" }
          }
        }
      },
      {
        path: ":id",
        name: "labelEntry.edit",
        component: AppLabelentriesItem,
        meta: {
          auth: {
            roles: "labelEntry.update",
            redirect: { name: "labelEntry.index" }
          }
        }
      }
    ]
  }
];

export default routes;
